import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Date from './date';
import cn from 'classnames';

import { Badge } from './badge';
import { H6, Muted, Text } from './text';
import { IFeaturedImage } from '../models/featured-image';

interface IProps {
	title: string;
	coverImage?: IFeaturedImage;
	slug: string;
	badge?: string;
	excerpt?: string;
	light?: boolean;
	date?: string;
}

export default function FeaturedNewsPost({ title, coverImage, slug, excerpt, badge, light, date }: IProps) {
	const textClassNames = cn({
		'text-white': light,
		'hover:underline': true,
	});

	return (
		<section className="mb-0">
			<div className="flex flex-col bg-transparent mb-0 h-auto max-h-[232px] overflow-hidden rounded-sm">
				{coverImage?.node.sourceUrl ? (
					<Link href={`/nieuws/${slug}`}>
						<Image
							width={800}
							height={400}
							alt={title}
							src={coverImage.node.sourceUrl}
							className="aspect-video object-cover rounded-t-sm"
						/>
					</Link>
				) : (
					<Link href={`/nieuws/${slug}`}>
						<div className="aspect-video bg-gray-200 flex items-center justify-center rounded-t-sm">
							<Text className="text-gray-800 text-base">Geen afbeelding beschikbaar</Text>
						</div>
					</Link>
				)}
			</div>
			{badge && <Badge className="mb-2">{badge}</Badge>}
			<div className="pl-0 pr-4 pt-2 pb-0">
				<H6 className="mb-2">
					<Link
						href={`/nieuws/${slug}`}
						className={textClassNames}
						dangerouslySetInnerHTML={{ __html: title }}
					></Link>
				</H6>
				{date && (
					<Muted className="uppercase mb-1 text-sm">
						<Date dateString={date} />
					</Muted>
				)}
				{excerpt && (
					<div className="block md:hidden line-clamp-2" dangerouslySetInnerHTML={{ __html: excerpt }} />
				)}
			</div>
		</section>
	);
}
